/* eslint-disable global-require */
import React from 'react';

import { SvgProps } from 'react-native-svg';

import { EventParentalControlRating } from 'services/data-manager/types';

import IconBookmarkSolid from './svgs/BottomBar/ico_bookmark_solid.svg';
import IconCatchup from './svgs/BottomBar/ico_catchup.svg';
import IconHome from './svgs/BottomBar/ico_home.svg';
import IconKids from './svgs/BottomBar/ico_kids.svg';
import IconMovies from './svgs/BottomBar/ico_movies.svg';
import IconOnDemand from './svgs/BottomBar/ico_on_demand.svg';
import IconPayPerView from './svgs/BottomBar/ico_pay_per_view.svg';
import IconRecordings from './svgs/BottomBar/ico_recordings.svg';
import IconSeries from './svgs/BottomBar/ico_series.svg';
import IconStar from './svgs/BottomBar/ico_star.svg';
import IconTv from './svgs/BottomBar/ico_tv.svg';
import IconTvSolid from './svgs/BottomBar/ico_tv_solid.svg';
import RoundedArrow from './svgs/Epg/arrow_rounded.svg';
import FullscreenIcon from './svgs/Player/ico_fullscreen.svg';
import ExitFullscreenIcon from './svgs/Player/ico_fullscreen_reverse.svg';
import LiveIcon from './svgs/Player/ico_live.svg';
import LockedIcon from './svgs/Player/ico_lock.svg';
import MiniPlayerIcon from './svgs/Player/ico_mini_player.svg';
import PlayerPauseIcon from './svgs/Player/ico_pause.svg';
import PlayerPlayIcon from './svgs/Player/ico_play.svg';
import PlayerSkipBwdIcon from './svgs/Player/ico_skip_bw.svg';
import PlayerSkipFwdIcon from './svgs/Player/ico_skip_fw.svg';
import StartoverIcon from './svgs/Player/ico_startover.svg';
import SubtitleIcon from './svgs/Player/ico_subtitles.svg';
import AddIcon from './svgs/ico_add.svg';
import AppStoreIcon from './svgs/ico_appstore.svg';
import LeftArrow from './svgs/ico_arrow_left.svg';
import RightArrow from './svgs/ico_arrow_right.svg';
import ArrowRightPlayerTitleSmall from './svgs/ico_arrow_right_player_title.svg';
import RightArrowSettings from './svgs/ico_arrow_right_settings.svg';
import ArrowRightSmall from './svgs/ico_arrow_right_small.svg';
import ButtonArrowDown from './svgs/ico_button_arrow.svg';
import IconChannelLineup from './svgs/ico_channel_lineup.svg';
import CheckBadgeIcon from './svgs/ico_check_badge.svg';
import CloseIcon from './svgs/ico_close_small.svg';
import IconComment from './svgs/ico_comment.svg';
import ConnectionIndicatorCellular from './svgs/ico_connection_indicator_cellular.svg';
import ConnectionIndicatorWifi from './svgs/ico_connection_indicator_wifi.svg';
import IconConsent from './svgs/ico_consent.svg';
import IconDeleteHistory from './svgs/ico_delete_history.svg';
import DragIcon from './svgs/ico_drag.svg';
import IconEpgDisplay from './svgs/ico_epg_display.svg';
import EyeIcon from './svgs/ico_eye.svg';
import EyeCrossedIcon from './svgs/ico_eye_crossed.svg';
import Filter from './svgs/ico_filter.svg';
import FilterOutline from './svgs/ico_filter_outline.svg';
import IconFlag from './svgs/ico_flag.svg';
import GalleryArrow from './svgs/ico_gallery_arrow.svg';
import GooglePlayIcon from './svgs/ico_googleplay.svg';
import IconHelp from './svgs/ico_help.svg';
import IconInfo from './svgs/ico_info.svg';
import IconParental from './svgs/ico_kids.svg';
import ProfileKidsIcon from './svgs/ico_kids_profile.svg';
import MoreInfoIcon from './svgs/ico_more_info.svg';
import NowIndicator from './svgs/ico_now_indicator.svg';
import ParentalRating6 from './svgs/ico_parental_rating_6.svg';
import ParentalRating12 from './svgs/ico_parental_rating_12.svg';
import ParentalRating16 from './svgs/ico_parental_rating_16.svg';
import ParentalRating18 from './svgs/ico_parental_rating_18.svg';
import ParentalRatingAdult from './svgs/ico_parental_rating_adult.svg';
import ParentalRatingGeneric from './svgs/ico_parental_rating_generic.svg';
import PencilIcon from './svgs/ico_pencil.svg';
import IconQuota from './svgs/ico_quota.svg';
import ReplayIcon from './svgs/ico_replay.svg';
import IconSearch from './svgs/ico_search.svg';
import IconSettings from './svgs/ico_settings.svg';
import UnsubscribedIcon from './svgs/ico_shopping_cart.svg';
import IconSignOut from './svgs/ico_sign_out.svg';
import IconSpotlight from './svgs/ico_spotlight.svg';
import ProfileStandardIcon from './svgs/ico_standard_profile.svg';
import StripeArrow from './svgs/ico_stripe_arrow.svg';
import IconSubscription from './svgs/ico_subscription.svg';
import IconUser from './svgs/ico_user.svg';
import IconInternetConnection from './svgs/ico_wifi.svg';
import AppLogo from './svgs/logo.svg';
import HeaderLogo from './svgs/logo_header.svg';

export const getMenuIcon = (icon: string): React.FC<SvgProps> | null => {
    switch (icon) {
        case 'ico_home':
            return IconHome;
        case 'ico_tv':
            return IconTv;
        case 'ico_tv_solid':
            return IconTvSolid;
        case 'ico_on_demand':
            return IconOnDemand;
        case 'ico_movies':
            return IconMovies;
        case 'ico_kids':
            return IconKids;
        case 'ico_series':
            return IconSeries;
        case 'ico_bookmark_solid':
            return IconBookmarkSolid;
        case 'ico_star':
            return IconStar;
        case 'ico_pay_per_view':
            return IconPayPerView;
        case 'ico_catchup':
            return IconCatchup;
        case 'ico_recordings':
            return IconRecordings;
        default:
            return null;
    }
};

export const getParentalRatingIcon = (
    parentalRating?: EventParentalControlRating,
) => {
    switch (parentalRating) {
        case EventParentalControlRating.HU6:
            return ParentalRating6;
        case EventParentalControlRating.HU12:
            return ParentalRating12;
        case EventParentalControlRating.HU16:
            return ParentalRating16;
        case EventParentalControlRating.HU18:
            return ParentalRating18;
        case EventParentalControlRating.HU18_ADULT:
            return ParentalRatingAdult;
        case EventParentalControlRating.HU18_ADULT_UC:
            return ParentalRatingAdult;
        default:
            return ParentalRatingGeneric;
    }
};

export const settingsIcons = {
    ico_flag: IconFlag,
    ico_kids: IconParental,
    ico_quota: IconQuota,
    ico_internet_connection: IconInternetConnection,
    ico_delete_history: IconDeleteHistory,
    ico_channel_lineup: IconChannelLineup,
    ico_subscription: IconSubscription,
    ico_comment: IconComment,
    ico_consent: IconConsent,
    ico_spotlight: IconSpotlight,
    ico_info: IconInfo,
    ico_help: IconHelp,
    ico_sign_out: IconSignOut,
    ico_epg_display: IconEpgDisplay,
};

// PlaceHolder
export const placeHolderPerson = require('./Stripe/placeHolderPerson.png');

// Settings
export const profilePlaceholder = require('./Profile/profile.png');

// Detail
export const placeHolderDetailLandscape = require('./Detail/detailPlaceHolderLandscape.jpg');

// Locked
export const lockedContentRight = require('./Stripe/lockedIconRight.jpg');
export const lockedContentCenter = require('./Stripe/lockedIconCenter.jpg');

export {
    AppLogo,
    HeaderLogo,
    ReplayIcon,
    UnsubscribedIcon,
    IconUser,
    IconSearch,
    IconSettings,
    StripeArrow,
    RightArrow,
    LeftArrow,
    RightArrowSettings,
    RoundedArrow,
    GalleryArrow,
    NowIndicator,
    MoreInfoIcon,
    AppStoreIcon,
    GooglePlayIcon,
    Filter,
    FilterOutline,
    ArrowRightSmall,
    ArrowRightPlayerTitleSmall,
    ButtonArrowDown,
    LockedIcon,
    LiveIcon,
    ConnectionIndicatorCellular,
    ConnectionIndicatorWifi,
    StartoverIcon,
    SubtitleIcon,
    MiniPlayerIcon,
    FullscreenIcon,
    ExitFullscreenIcon,
    CloseIcon,
    AddIcon,
    CheckBadgeIcon,
    PencilIcon,
    PlayerPlayIcon,
    PlayerPauseIcon,
    PlayerSkipBwdIcon,
    PlayerSkipFwdIcon,
    ProfileKidsIcon,
    ProfileStandardIcon,
    DragIcon,
    EyeIcon,
    EyeCrossedIcon,
};
